<template>
    <div class="wrapper">
        <div class="contacts">
            <p style="margin-bottom:10px;"><strong>LD power automation</strong></p>
            <p>1379 W Park Western Dr #283</p>
            <p>San Pedro, CA 90732</p>
            <p>USA</p>
            <hr/>
            <p>Tel: +1 310 7071115</p>
            <p>Fax: +1 310 6269486</p>
            <p>E-mail: info@ldpa.us</p>
            <p><a href="www.ldpa.com">www.ldpa.com</a></p>
        </div>
        <div>
            <p> 
                Our regular business hours are Monday to Friday, 8:00 to 16:00 PST (GMT -8).
                <br/>For your convenience, our engineers are available 24 hours a day, 7 days a week for any emergency situation your company may incur.
            </p>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
	name: 'contact',
	data() {
		return {
			
		}
	},
}
</script>

<style scoped>
.wrapper {
    width: 100%;
    display: flex;
    color:black;
    font-size: 16px;
    letter-spacing: .05em;
    gap:44px;
}

.contacts {
    flex-direction: column;
    gap:0px;
}

.contacts p {
    margin: 0px 20px;
}

.contacts hr {
    background:black;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Contact.vue